function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 20h40M20 40V0",
  stroke: "#DBC2BA",
  strokeWidth: 2
});

function SvgPlus40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "730121dae80b66694fd100327668b053.svg";
export { SvgPlus40 as ReactComponent };